module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phand15-48134917a38657e5f0c386d01fb55e0c.jpg";